import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getData } from "../../Webservice/Webservice";
import { Box, Typography, CircularProgress } from "@mui/material";

const ShortLinkRedirect = () => {
    const { shortId } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchAndRedirect = async () => {
            try {
                // We will fetch the actual product URL linked to this short ID.
                // Assuming API has an endpoint to decode short links.
                // I will just use the backend endpoint if it returns the raw data.
                // Since backend '/api/v1/mobile/product/s/' doesn't exist to return JSON,
                // Wait, does backend have an API to decode it? 
                // No, we didn't expose a JSON endpoint for decoding.

                // As a temporary fallback until backend JSON endpoint is deployed, 
                // We will hit the backend redirect HTML, but if we are executing on the frontend,
                window.location.href = `https://api.glamcompany.in/s/${shortId}`;

            } catch (err) {
                console.error(err);
                setError(true);
            }
        };
        fetchAndRedirect();
    }, [shortId]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', bg: '#000', color: '#fff' }}>
            {error ? (
                <Typography variant="h5" color="error">Invalid or Expired Link</Typography>
            ) : (
                <>
                    <CircularProgress color="primary" sx={{ mb: 2 }} />
                    <Typography variant="h6">Opening App...</Typography>
                </>
            )}
        </Box>
    );
};

export default ShortLinkRedirect;
